var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},[(!this.$store.getters.forceOffline)?_c('audio',{ref:"alertAudio",attrs:{"src":_vm.alarmSource,"type":"audio/mpeg","loop":"","mute":""}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.alertsAudioOn))])])
}
var staticRenderFns = []

export { render, staticRenderFns }